<template>
  <div class="page-404">
    <div class="page-404__bg"></div>
    <div class="book-open">
      <div class="book-open__spine"></div>
      <div class="book-open__left">
        <div class="book-open__page-lines">
          <span></span><span></span><span></span>
        </div>
        <h1 class="book-open__404">404</h1>
        <div class="book-open__page-lines book-open__page-lines--bottom">
          <span></span><span></span>
        </div>
      </div>
      <div class="book-open__right">
        <div class="book-open__illustration">
          <svg viewBox="0 0 80 80" fill="none" stroke="#c4b5fd" stroke-width="1.5">
            <circle cx="40" cy="32" r="16"/>
            <path d="M20 70c0-11 9-20 20-20s20 9 20 20"/>
            <path d="M32 30c0 0 3 4 8 4s8-4 8-4" stroke-width="1.2"/>
            <circle cx="34" cy="28" r="1.5" fill="#c4b5fd" stroke="none"/>
            <circle cx="46" cy="28" r="1.5" fill="#c4b5fd" stroke="none"/>
          </svg>
        </div>
        <p class="book-open__message">{{ $t('notFound.message') }}</p>
        <p class="book-open__hint">{{ $t('notFound.hint') }}</p>
      </div>
    </div>
    <router-link to="/" class="book-open__btn">
      <button class="btn gradient">
        {{ $t('notFound.button') }}
        <span class="cta-arrow">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </span>
      </button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss">
@import '../../styles/variables';

.page-404 {
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  position: relative;
  overflow: hidden;

  &__bg {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    pointer-events: none;

    &::before {
      content: '';
      position: absolute;
      top: 20%;
      left: -10%;
      width: 50%;
      height: 60%;
      background: radial-gradient(ellipse at center, rgba(200, 180, 240, 0.35) 0%, transparent 65%);
      filter: blur(60px);
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 10%;
      right: -10%;
      width: 50%;
      height: 60%;
      background: radial-gradient(ellipse at center, rgba(170, 230, 220, 0.3) 0%, transparent 65%);
      filter: blur(60px);
    }
  }
}

.book-open {
  display: flex;
  position: relative;
  max-width: 680px;
  width: 100%;
  margin-bottom: 2.5rem;
  z-index: 1;

  // 书脊
  &__spine {
    position: absolute;
    top: -8px;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 6px;
    background: linear-gradient(to bottom, #d4d0e8, #b8b0d4, #d4d0e8);
    border-radius: 3px;
    z-index: 2;
    box-shadow: 0 0 12px rgba(81, 45, 202, 0.15);
  }

  // 左页
  &__left {
    flex: 1;
    background: #fff;
    border-radius: 4px 0 0 4px;
    padding: 3rem 2.5rem;
    box-shadow:
      -4px 4px 16px rgba(0, 0, 0, 0.06),
      -1px 0 0 #e8e5f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 30px;
      height: 100%;
      background: linear-gradient(to left, rgba(0,0,0,0.02), transparent);
    }
  }

  // 右页
  &__right {
    flex: 1;
    background: #fff;
    border-radius: 0 4px 4px 0;
    padding: 3rem 2.5rem;
    box-shadow:
      4px 4px 16px rgba(0, 0, 0, 0.06),
      1px 0 0 #e8e5f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 30px;
      height: 100%;
      background: linear-gradient(to right, rgba(0,0,0,0.02), transparent);
    }
  }

  &__404 {
    font-size: 7rem;
    font-weight: 900;
    color: $el-color-primary;
    line-height: 1;
    letter-spacing: -0.03em;
    opacity: 0.9;
  }

  &__page-lines {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 80%;
    margin-bottom: 1.5rem;

    &--bottom {
      margin-bottom: 0;
      margin-top: 1.5rem;
    }

    span {
      display: block;
      height: 3px;
      background: #f0eef5;
      border-radius: 2px;

      &:nth-child(1) { width: 100%; }
      &:nth-child(2) { width: 75%; }
      &:nth-child(3) { width: 60%; }
    }
  }

  &__illustration {
    width: 80px;
    height: 80px;
    margin-bottom: 1.5rem;
    opacity: 0.6;
  }

  &__message {
    font-size: 1.25rem;
    font-weight: 600;
    color: #374151;
    text-align: center;
    margin: 0 0 0.5rem;
  }

  &__hint {
    font-size: 0.875rem;
    color: #9ca3af;
    text-align: center;
    margin: 0;
  }

  &__btn {
    z-index: 1;
    text-decoration: none;

    .btn {
      padding: 0.75rem 2.5rem;
      font-size: 1rem;
    }
  }
}

@media (max-width: 768px) {
  .book-open {
    flex-direction: column;
    max-width: 360px;

    &__spine {
      top: auto;
      left: -8px;
      right: -8px;
      bottom: 50%;
      transform: translateY(50%);
      width: auto;
      height: 6px;
    }

    &__left {
      border-radius: 4px 4px 0 0;
      min-height: 200px;
      padding: 2rem;
      box-shadow:
        0 -4px 16px rgba(0, 0, 0, 0.06),
        0 -1px 0 #e8e5f0;

      &::before {
        top: auto;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 30px;
        background: linear-gradient(to top, rgba(0,0,0,0.02), transparent);
      }
    }

    &__right {
      border-radius: 0 0 4px 4px;
      min-height: 200px;
      padding: 2rem;
      box-shadow:
        0 4px 16px rgba(0, 0, 0, 0.06),
        0 1px 0 #e8e5f0;

      &::before {
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 30px;
        background: linear-gradient(to bottom, rgba(0,0,0,0.02), transparent);
      }
    }

    &__404 {
      font-size: 5rem;
    }
  }
}
</style>
